'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = undefined;

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _module = require('../components/PushCart/module.pushcart');

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var createStore = exports.createStore = function createStore(_ref) {
  var pushCart = _ref.initialData.pushCart;

  var modules = {
    pushCart: (0, _module2.default)(pushCart)
  };

  var store = new _vuex2.default.Store({
    modules: modules,
    state: {},
    actions: {},
    mutations: {},
    getters: {}
  });

  return store;
};